var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"active":_vm.loginActive,"width":568},on:{"update:active":function($event){_vm.loginActive=$event},"close":_vm.clearStore}},[_c('login-signup',{attrs:{"redirectPath":_vm.redirectPath,"success-notification-message":_vm.loginSuccessMessage},on:{"success":_vm.handleLoginSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }